import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Flex } from "../Box";
import { StyledFooter, CustomFlex, CustomLink, HeadTitle, ContainerMoreInformation, ContainerContact, ContainerInfo, CsTextEmail } from "./styles";
import { MoreInformation } from "./config";
import SocialLinks from "./Components/SocialLinks";
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        borderTop: "1px solid #777E91",
        p: [
            "40px 6px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsx(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: /*#__PURE__*/ _jsxs(CustomFlex, {
                children: [
                    /*#__PURE__*/ _jsx(Flex, {
                        children: /*#__PURE__*/ _jsx("img", {
                            style: {
                                objectFit: "contain",
                                height: "90px",
                                width: "100px"
                            },
                            src: "/logo.png",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ _jsx(ContainerInfo, {
                        children: /*#__PURE__*/ _jsx(ContainerMoreInformation, {
                            children: MoreInformation.map(function(items) {
                                return /*#__PURE__*/ _jsx(CustomLink, {
                                    href: items.href,
                                    target: "_blank",
                                    children: items.label
                                });
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(ContainerContact, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ _jsx(HeadTitle, {
                                children: "Contact"
                            }),
                            /*#__PURE__*/ _jsx(CsTextEmail, {
                                children: "hello@runtogether.net"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(ContainerContact, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ _jsx(HeadTitle, {
                                children: "Follow us"
                            }),
                            /*#__PURE__*/ _jsx(SocialLinks, {
                                order: [
                                    2
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
export default MenuItem;
